module.exports = __webpack_public_path__ + "static/media/Fresh_Pack_Honey_10.375d3b7f.png";